"use client";

import { useEffect } from "react";
import { installClientCapture } from "@/lib/observe/client";

export default function CaptureBootstrap() {
  useEffect(() => {
    installClientCapture();
  }, []);
  return null;
}
